
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Sinvoice } from './s-invoice';
import { Service } from './service';
import { Visit } from 'src/app/assabil-kernel/models/entities/master-data/visit-entity';
import { PaymentTerm } from 'src/app/assabil-kernel/models/entities/control-tables/payment-term';
import { Bank } from 'src/app/assabil-kernel/models/entities/control-tables/bank';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';


export class Payment extends BaseEntity {

  paymentCode     : string;
  
  sinvoice        : Sinvoice  = new Sinvoice();
  service         : Service   = new Service();
  visit           : Visit     = new Visit();
  partner         : Partner   = new Partner();  
  role            : Role      = new Role();
  person          : Person    = new Person();

  paymentTerm     : PaymentTerm    = new PaymentTerm();
  amount          : number ;
  theDate         : Date;
  maturityDate    : Date;
  canceled        : boolean;
  reference       : string ;
  payerReference  : string ;
  
  bank            : Bank = new Bank();

  constructor() {
    super();

  }
}
 
 
